import { EMPTY_ACCOMMODATION_LIST_TOTAL } from "../constants/accommodationStockConstants";
import { AccommodationStock, AccommodationStockTotal } from "../objects/accommodationStockList";


export const getAccommodationTotal = (accommodation_list: AccommodationStock[]): AccommodationStockTotal => {
    const accommodation_total: AccommodationStockTotal = {
        ...EMPTY_ACCOMMODATION_LIST_TOTAL,
        stocks: {
            ...EMPTY_ACCOMMODATION_LIST_TOTAL.stocks,
            days: { ...EMPTY_ACCOMMODATION_LIST_TOTAL.stocks.days } // Ensure stocks.days is mutable
        },
        selling_stocks: {
            ...EMPTY_ACCOMMODATION_LIST_TOTAL.selling_stocks,
            days: { ...EMPTY_ACCOMMODATION_LIST_TOTAL.selling_stocks.days } // Ensure selling_stocks.days is mutable if needed
        }
    };

    accommodation_list.forEach((accommodation) => {
        accommodation.rooms.forEach((room) => {
            Object.entries(room.room_stocks).forEach(([date, stock]) => {
                accommodation_total.stocks.days[date] = (Number(accommodation_total.stocks.days[date]) || 0) + (Number(stock.value) || 0);
                accommodation_total.stocks.total = (Number(accommodation_total.stocks.total) || 0) + (Number(stock.value) || 0);
            });
            Object.entries(room.client_stocks).forEach(([date, stock]) => {
                accommodation_total.selling_stocks.days[date] = (Number(accommodation_total.selling_stocks.days[date]) || 0) + (Number(stock.total_bought) || 0);
                accommodation_total.selling_stocks.total = (Number(accommodation_total.selling_stocks.total) || 0) + (Number(stock.total_bought) || 0);
            });
        });
    });
    return accommodation_total;
};

export const calculAccommodationStockSubTotal = (accommodation_list: AccommodationStock[]): AccommodationStock[] => accommodation_list.map((accommodation) => {
    const total_stocks: AccommodationStockTotal = {
        ...EMPTY_ACCOMMODATION_LIST_TOTAL,
        stocks: {
            ...EMPTY_ACCOMMODATION_LIST_TOTAL.stocks,
            days: { ...EMPTY_ACCOMMODATION_LIST_TOTAL.stocks.days } // Ensure stocks.days is mutable
        },
        selling_stocks: {
            ...EMPTY_ACCOMMODATION_LIST_TOTAL.selling_stocks,
            days: { ...EMPTY_ACCOMMODATION_LIST_TOTAL.selling_stocks.days } // Ensure selling_stocks.days is mutable if needed
        }
    };

    accommodation.rooms.forEach((room) => {
        Object.entries(room.room_stocks).forEach(([date, stock]) => {
            total_stocks.stocks.days[date] = (Number(total_stocks.stocks.days[date]) || 0) + (Number(stock.value) || 0);
            total_stocks.stocks.total = (Number(total_stocks.stocks.total) || 0) + (Number(stock.value) || 0);
        });
        Object.entries(room.client_stocks).forEach(([date, stock]) => {
            total_stocks.selling_stocks.days[date] = (Number(total_stocks.selling_stocks.days[date]) || 0) + (Number(stock.total_bought) || 0);
            total_stocks.selling_stocks.total = (Number(total_stocks.selling_stocks.total) || 0) + (Number(stock.total_bought) || 0);
        });
    });
    return ({
        ...accommodation,
        total_stocks
    });
});